import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiurl } from "../../common/constants";
import Alert from "../Alert";
import UploadProgressBar from "../subcomponents/UploadProgressBar";
import { useStore } from "../../context/StoreContext";
import EditBrand from "./EditBrand"; 
import { useAuthAxios } from "../authfetch"; 

const AddBrand = ({ updates, setUpdates }) => {
  const { brands, setToast } = useStore();
  const navigate = useNavigate();
  const authAxios = useAuthAxios();
  
  const [formData, setFormData] = useState({
    brandName: "",
    brandDesc: "",
    ownBrand: false
  });
  const [brandImage, setBrandImage] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [brandAlert, setBrandAlert] = useState(null);
  const [showProgress, setShowProgress] = useState(false);
  
  const formRef = useRef(null);
  const fileInputRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFileChange = (e) => {
    setBrandImage(e.target.files[0]);
  };

  const handleAddBrand = async (e) => {
    e.preventDefault();
    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      return;
    }

    const { brandName, brandDesc, ownBrand } = formData;
    const formattedBrandName = brandName.charAt(0).toUpperCase() + brandName.slice(1);

    const submitData = new FormData();
    submitData.append("brandName", formattedBrandName);
    submitData.append("brandDesc", brandDesc);
    submitData.append("brandImage", brandImage);
    submitData.append("ownBrand", ownBrand);

    setShowProgress(true);
    setBrandAlert(null);

    try {
      const { data } = await authAxios.post(`${apiurl}/brands`, submitData, {
        headers: { 
          'Content-Type': undefined 
        },
        onUploadProgress: (event) => {
          const percent = (event.loaded / event.total);
          setUploadProgress(percent);
        }
      });

      setBrandAlert({ message: data.message, type: "success" });
      
      // Reset form
      setFormData({ brandName: "", brandDesc: "", ownBrand: false });
      setBrandImage(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      
      // Trigger updates if needed (using context)
       setUpdates(prev => ({...prev, brandUpdates: prev.brandUpdates + 1}));

    } catch (err) {
      console.error("error occurred: ", err);
      setToast({ show: true, message: err.response?.data?.message || "Something went wrong", type: "error" });
    } finally {
      setShowProgress(false);
    }
  };

  return (
    <>
      {brandAlert && <div className="mb-3"><Alert message={brandAlert.message} type={brandAlert.type} /></div>}
      <form className='addBrandForm' ref={formRef} onSubmit={handleAddBrand}>
        <div className="input-group mb-3">
          <span className="input-group-text">Name</span>
          <input 
            type="text" 
            required 
            className="form-control" 
            placeholder="New Brand Name" 
            name="brandName"
            value={formData.brandName}
            onChange={handleInputChange}
          />
        </div>
        <div className="input-group">
          <span className="input-group-text">Desc&nbsp;</span>
          <textarea 
            required 
            className="form-control" 
            placeholder='Brand Description' 
            style={{ height: "150px" }}
            name="brandDesc"
            value={formData.brandDesc}
            onChange={handleInputChange}
          ></textarea>
        </div>
        <div className="my-3">
          <input 
            className="form-control" 
            type="file" 
            required
            ref={fileInputRef}
            onChange={handleFileChange}
          />
        </div>
        
        {showProgress && (
          <UploadProgressBar 
            uploadProgressValue={uploadProgress} 
            progressBarId="progressAddBrand" 
            style={{display: "block"}}
          />
        )}
        
        <div className='mb-4'>
          <div className="form-check form-switch">
            <input 
              className="form-check-input" 
              type="checkbox" 
              role="switch" 
              id="ownBrand" 
              style={{ border: "2px solid #4c4747" }} 
              name="ownBrand"
              checked={formData.ownBrand}
              onChange={handleInputChange}
            />
            <label className="form-check-label" htmlFor="ownBrand">Own Brand</label>
          </div>
        </div>

        <button type="submit" className="btn btn-primary">Add Brand</button>
        <button type="button" className="btn btn-success mx-4" data-bs-toggle="modal" data-bs-target="#editBrandModel">
          Edit Brand
        </button>
      </form>
      
      <EditBrand brands={brands} updates={updates} setUpdates={setUpdates} navigate={navigate} />
    </>
  );
}

export default AddBrand;